import produce from 'immer'
import { assign, findIndex, pick } from 'lodash'

import { areSameValue } from '../../../core/utils'

import {
  CONFIRM_UNKNOWN_WORD,
  DELETE_NOT_EXPORTED_UNKNOWN_WORD,
  FETCH_UNKNOWN_WORDS,
  UNCONFIRM_UNKNOWN_WORD,
} from '../action-types'
import { UNKNOWN_WORDS_INITIAL_STATE } from '../initial-states'

const unknownWordsReducer = (state = UNKNOWN_WORDS_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_UNKNOWN_WORDS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: {},
        }),
      )

    case FETCH_UNKNOWN_WORDS.COMPLETE:
      return produce(state, nextState => {
        const results = action.payload.data.unknownWords

        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: results,
        })
      })

    case FETCH_UNKNOWN_WORDS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: {},
        }),
      )

    case CONFIRM_UNKNOWN_WORD.START:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )
        assign(nextState.data?.result[index], {
          error: undefined,
          isLoading: true,
        })
      })

    case CONFIRM_UNKNOWN_WORD.COMPLETE:
      return produce(state, nextState => {
        const { confirmUnknownWord: unknownWord } = action.payload.data

        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, unknownWord.id),
        )

        assign(nextState.data?.result[index], {
          ...unknownWord,
          isLoading: false,
          error: undefined,
        })
      })

    case CONFIRM_UNKNOWN_WORD.FAIL:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )
        assign(nextState.data?.result[index], {
          error: action.error.message,
          isLoading: false,
        })
      })

    case UNCONFIRM_UNKNOWN_WORD.START:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )
        assign(nextState.data?.result[index], {
          error: undefined,
          isLoading: true,
        })
      })

    case UNCONFIRM_UNKNOWN_WORD.COMPLETE:
      return produce(state, nextState => {
        const { unconfirmUnknownWord: unknownWord } = action.payload.data

        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, unknownWord.id),
        )

        assign(nextState.data?.result[index], {
          ...unknownWord,
          isLoading: false,
          error: undefined,
        })
      })

    case UNCONFIRM_UNKNOWN_WORD.FAIL:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )
        assign(nextState.data?.result[index], {
          error: action.error.message,
          isLoading: false,
        })
      })

    case DELETE_NOT_EXPORTED_UNKNOWN_WORD.START:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )
        assign(nextState.data?.result[index], {
          deleteError: undefined,
          isDeleteLoading: true,
        })
      })

    case DELETE_NOT_EXPORTED_UNKNOWN_WORD.COMPLETE:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.variables.id),
        )

        nextState.data?.result?.splice(index, 1)
      })

    case DELETE_NOT_EXPORTED_UNKNOWN_WORD.FAIL:
      return produce(state, nextState => {
        const index = findIndex(state?.data?.result, ({ id }) =>
          areSameValue(id, action.payload.id),
        )
        assign(nextState.data?.result[index], {
          deleteError: action.error.message,
          isDeleteLoading: false,
        })
      })

    case FETCH_UNKNOWN_WORDS.CLEANUP:
      return produce(state, nextState =>
        assign(
          nextState,
          pick(UNKNOWN_WORDS_INITIAL_STATE, ['error', 'isLoading', 'data']),
        ),
      )
    default:
      return state
  }
}

export default unknownWordsReducer
